import React from 'react';
import Drawer from '../Common/Drawer/Drawer';
import SampleForm from './drawers/SampleForm';

export default class Index extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            drawerThinOpen: false,
            drawerWideOpen: false,
            drawerWithChild: false,
        };

    }

    //############## Drawer functions ###############
    toggleThinDrawer = () => {
        this.setState({ drawerThinOpen: true });
    }

    toggleWideDrawer = () => {
        this.setState({ drawerWideOpen: true });
    }

    drawerThinSaveClick = () => {
        this.setState({ drawerThinOpen: false });
    }

    drawerThinCancelClick = () => {
        this.setState({ drawerThinOpen: false });
    }
    drawerWideSaveClick = () => {
        this.setState({ drawerWideOpen: false });
    }

    drawerWideCancelClick = () => {
        this.setState({ drawerWideOpen: false });
    }

    //############## Drawer functions ###############

    render() {

        let sampleDrawerForm = <SampleForm />;

        return (
            <div className="guide-page">
                <h3 className="guide-title">Drawer</h3>
                <p className="guide-lead">How to use the drawer component and the difference between thin and wide.</p>

                <div className="component">
                    <label>Parameters:</label>
                    <div className="param"><span className="param-name">isOpen</span><span className="param-type">[bool]</span><span className="param-desc">A state property that manages the open/close of the drawer</span></div>
                    <div className="param"><span className="param-name">isWide</span><span className="param-type">[bool]</span><span className="param-desc">Sets the width of the drawer for desktop view</span></div>
                    <div className="param"><span className="param-name">title</span><span className="param-type">[string]</span><span className="param-desc">The title text that appears on the top bar of the drawer</span></div>
                    <div className="param"><span className="param-name">saveText</span><span className="param-type">[string]</span><span className="param-desc">The text of the primary save button</span></div>
                    <div className="param"><span className="param-name">onCancelClick</span><span className="param-type">[func]</span><span className="param-desc">The function that gets called when the cancel button is clicked</span></div>
                    <div className="param"><span className="param-name">children</span><span className="param-type">[array or element]</span><span className="param-desc">You may pass in a single element or multiple to be rendered inside the drawer</span></div>
                </div>
                <hr />
                <div className="guide-article">
                    <h4>Thin drawer</h4>
                    <p>The thin drawer is the most commonly used drawer. It allows for 1 vertical column of form values and takes up the entire screen on mobile.</p>
                    <button className="btn btn-primary me-2" onClick={this.toggleThinDrawer}>Open Thin Drawer</button>
                </div>

                <div className="guide-article">
                    <h4>Wide drawer</h4>
                    <p>The wide drawer is twice the width of the thin drawer on desktop, but on mobile it will appear to be the same and will still cover the entire screen.</p>
                    <button className="btn btn-primary" onClick={this.toggleWideDrawer}>Open Wide Drawer</button>
                </div>


                {this.state.drawerThinOpen ?
                    <Drawer isWide={false} title="The thin Header" onSaveClick={this.drawerThinSaveClick} onCancelClick={this.drawerThinCancelClick}>
                        {sampleDrawerForm}
                    </Drawer>                
                :
                ""
                }
                {this.state.drawerWideOpen ?
                    <Drawer isWide={true} title="The wide Header" onSaveClick={this.drawerWideSaveClick} onCancelClick={this.drawerWideCancelClick}>
                        {sampleDrawerForm}
                    </Drawer>                
                :
                ""
                }
            </div>
        );
    }
}
